import { Card } from '@/components/ui/card'
import { useStytchWorkspaces } from '@/hooks/useStytchWorkspaces'
import { setIsCreateWorkspaceDialogOpen } from '@/redux/store/slices/ui/uiSlice'
import { useAppDispatch } from '@redux/hooks/useAppState'

import HomePageBackground from '../../assets/images/HomePageBackground.png'
import { WorkspaceList } from '../WorkspaceList/WorkspaceList'

import type { FC } from 'react'

export const Dashboard: FC = () => {
	const dispatch = useAppDispatch()
	const { workspaces = [], isLoading: fetchingWorkspaces } = useStytchWorkspaces()

	const handleAddWorkspace = () => {
		dispatch(setIsCreateWorkspaceDialogOpen(true))
	}

	return (
		<div className="flex flex-col h-screen">
			<div
				className="flex-1 flex justify-center p-8"
				style={{
					backgroundImage: `url(${HomePageBackground})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center center',
				}}
			>
				<div className="w-full max-w-2xl">
					<Card>
						<WorkspaceList
							workspaces={workspaces}
							onAddNew={handleAddWorkspace}
							isLoading={fetchingWorkspaces}
						/>
					</Card>
				</div>
			</div>
		</div>
	)
}
